<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="[24, 24]">
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="统一社会信用代码" prop="creditCode">
            <a-input v-model="form.creditCode" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="期望年份" prop="hopeYear">
            <a-date-picker
              v-model="form.hopeYear"
              mode="year"
              :open="isOpen"
              format="YYYY"
              style="width:100%;"
              placeholder="请选择期望年份"
              @openChange="handleOpenChange"
              @panelChange="handlePanelChange"
              @change="handleChange"
              class="year-date"
            />
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="客户编号" prop="companyCode">
            <a-input v-model="form.companyCode" disabled />
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="客户名称" prop="companyName">
            <a-input v-model="form.companyName" disabled />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { getCustomerOverview } from 'views/client/client-center/detail/mechanism/api'
import moment from 'moment'
export default {
  data() {
    return {
      form: { creditCode: '', hopeYear: '', companyName: '', companyCode: '' },
      isOpen: false,
      rules: {
        creditCode: [
          {
            required: true,
            message: '请填写统一社会信用代码',
            trigger: 'blur',
          },
        ],
        hopeYear: [
          {
            required: true,
            message: '请填写期望年限',
            trigger: 'change',
          },
        ],
        companyName: [
          { required: true, message: '请填写客户名称', trigger: 'change' },
        ],
        companyCode: [
          {
            required: true,
            message: '请填写客户编号',
            trigger: 'change',
          },
        ],
      },
    }
  },
  created() {
    this._getCustomerInfo()
    this._initFormDefaultValue()
  },

  methods: {
    _initFormDefaultValue() {
      this.form.hopeYear = this.$route.query.hopeYear
    },
    handleOpenChange(status) {
      this.isOpen = status
    },
    handlePanelChange(value) {
      this.form.hopeYear = moment(value).format('YYYY')
      this.isOpen = false
    },
    handleChange() {
      this.form.hopeYear = null
    },
    async _getCustomerInfo() {
      try {
        const { data } = await getCustomerOverview(this.$route.params.id)
        if (data.base.registeredNo && data.base.registeredNo !== '') {
          this.form.creditCode = data.base.registeredNo
          this.form.companyName = data.base.name
          this.form.companyCode = data.base.code
        } else {
          this.form.creditCode = '请到客户信息页完善信用代码'
        }
      } catch (e) {
        console.log(e)
      }
    },
    async validate() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        delete this.form.companyCode
        const result = { ...this.form }
        return result
      }
    },
  },
}
</script>
<style lang="less" scoped></style>
